import { Pipe, PipeTransform, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { IconService } from '@common/services/icons.service';

@Pipe({
  standalone: true,
  name: 'objectIcon',
  pure: true,
})
export class ObjectIconPipe implements PipeTransform {
  private readonly iconService = inject(IconService);

  transform(id: number): SafeHtml | undefined {
    return this.iconService.getObjectIcon(id);
  }
}
